import {
    type TextStyle
} from "react-native";
import type {
    FieldDescriptionDynamicStyleConstantType,
    FieldDescriptionColorsConstantType,
    FieldDescriptionDynamicStyleType,
    FieldDescriptionColorsType
} from "./type";
import type {
    Mutable
} from "../../../../types";

export const FIELD_DESCRIPTION_VARIANT: keyof NCoreUIKit.Typography = "bodyMediumSize";

export const getFieldDescriptionColors = ({
    isDisabled,
    colors
}: FieldDescriptionColorsConstantType): FieldDescriptionColorsType => {
    return {
        color: isDisabled ? colors.content.text.disabled : colors.content.text.mid
    };
};

export const useStyles = ({
    isInSet,
    spaces
}: FieldDescriptionDynamicStyleConstantType): FieldDescriptionDynamicStyleType => {
    const description = {} as Mutable<TextStyle>;

    if(isInSet) {
        description.marginTop = spaces.spacingXs - spaces.spacingLg;
    }

    return {
        description
    };
};
